import { render } from "./AdminFormSelect.vue?vue&type=template&id=54df96b4&scoped=true"
import script from "./AdminFormSelect.vue?vue&type=script&lang=js"
export * from "./AdminFormSelect.vue?vue&type=script&lang=js"

import "./AdminFormSelect.vue?vue&type=style&index=0&id=54df96b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54df96b4"]])

export default __exports__